import { TableLayoutMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/layout/table-layout-metadata.model";
import { MetadataFactory } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.factory";
import { Identified } from "./identified.model";
import { Layout } from "./layout.model";
import { RowLayout } from "./row-layout.model";



export class TableLayout implements Layout, Identified {

    rows: RowLayout [] = []
    metadata: TableLayoutMetadata

    slotsCapacity: number = 6
    icon: string = 'table_rows'


    constructor(meta?: TableLayoutMetadata) {
        this.metadata = meta ? meta : MetadataFactory.createTableLayout()
    }

    id(): string {
        return this.metadata.id
    }

    label(): string {
        return this.metadata.name
    }

    removeRow(row: RowLayout) {
        this.rows = this.rows.filter(r => r != row)
    }

    getRows(): RowLayout [] {
        return this.rows
    }

    layout(): TableLayoutMetadata {
        return this.metadata
    }

}